"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface Company {
  id: string;
  company_name: string;
}

export default function SelectCompanyPage() {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const [companies, setCompanies] = useState<Company[]>([]);
  const router = useRouter();

  useEffect(() => {
    const fetchCompanies = async () => {
      const res = await fetch("/api/company");
      const data = await res.json();
      if (data.success) {
        setCompanies(data.data);
        console.log(data.data);
      }
    };
    fetchCompanies();
  }, []);

  const handleSubmit = () => {
    const selectedCompany = companies.find((company) => company.company_name === value);
    if (selectedCompany) {
      router.push(`/company/${selectedCompany.id}`);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-6">
      
    </div>
  );
}
